import { render, staticRenderFns } from "./pricingList.vue?vue&type=template&id=58707e20&scoped=true&"
import script from "./pricingList.vue?vue&type=script&lang=js&"
export * from "./pricingList.vue?vue&type=script&lang=js&"
import style0 from "./pricingList.vue?vue&type=style&index=0&id=58707e20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58707e20",
  null
  
)

export default component.exports